"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPlay = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M16.62 60.76a1.58 1.58 0 0 1-.79-.21 1.61 1.61 0 0 1-.83-1.39V10.84a1.61 1.61 0 0 1 2.4-1.39l41.87 24.16a1.61 1.61 0 0 1 0 2.78L17.42 60.55a1.59 1.59 0 0 1-.8.21zm1.61-47.15v42.78L55.27 35z"
  })),
  height: undefined,
  width: undefined
});
IconPlay.displayName = 'IconPlay';
var _default = IconPlay;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/play.js
// module id = 578
// module chunks = 0